import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Language from './Language';
import LanguageHelp from './../content/LanguageHelp';
import Legend from '../Legend/Legend';
import Letters from './Letters';
import { v4 as uuidv4 } from 'uuid';
import { DEF } from '../../service/constants';
import { getConfig } from '../../service/config';


const Alphabet = () => {
    const upcase = useSelector(state => state.upcase);
    const currentLang = useSelector(state => state.currentLang);
    const allsigns = useSelector(state => state.allsigns);
    const rus = useSelector(state => state.rus);
    const langGroup = useSelector(state => state.langGroup?.script);

    const dispatch = useDispatch();

    useEffect(() => {
        let curlng = currentLang ? currentLang : null
        if (curlng && langGroup) { // Добавляем проверку на langGroup
            const jsonPath = getConfig().JSON_PATH;
            const siteUrl = jsonPath + 'site/' + langGroup + '/base/' + curlng + '.json';
            const libraryUrl = jsonPath + 'library/' + langGroup + '/base/' + curlng + '.json';
            
            fetch(siteUrl)
                .then(res => {
                    if (!res.ok) {
                        throw new Error(`HTTP error! status: ${res.status}`);
                    }
                    return res.json();
                })
                .then(data => {
                    dispatch({ type: 'setAllSigns', payload: data });
                })
                .catch(error => {
                    console.error('Alphabet - error loading site data:', error);
                });
                
            fetch(libraryUrl)
                .then(res => {
                    if (!res.ok) {
                        throw new Error(`HTTP error! status: ${res.status}`);
                    }
                    return res.json();
                })
                .then(data => {
                    dispatch({ type: 'setLanguage', payload: data });
                    dispatch({ type: 'switchLang', payload: data.local });
                })
                .catch(error => {
                    console.error('Alphabet - error loading library data:', error);
                });
        }
    }, [currentLang, langGroup]); // Добавляем langGroup в зависимости



    
    if (currentLang)
        return (<>
            <Language />
            <Legend showtable showhelp />

            <div className={`lettersblock${upcase ? '' : ' hidden'}`}>
                {allsigns?.glyphs_list?.map(set => {
                    return (<Letters alpahabet={set.uppercase} title={DEF[set.type]?.title[rus]} showUni={set.show_unicodes} key={uuidv4()} />)
                })}
            </div>

            <div className={`lettersblock${upcase ? ' hidden' : ''}`}>
                {allsigns?.glyphs_list?.map(set => {
                    return (<Letters alpahabet={set.lowercase} title={DEF[set.type]?.title[rus]} showUni={set.show_unicodes} key={uuidv4()} />)
                })}
            </div>
        </>);
    else return (<LanguageHelp />)
};
export default Alphabet;


